import { Component } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { map } from 'rxjs';
import { PraticaProgressService } from '../../_core/services/pratica-progress.service';
import { SharedModule } from '../../_shared/shared.module';
import { PraticaTitleComponent } from '../pratica-title/pratica-title.component';

@Component({
  selector: 'app-status-bar',
  standalone: true,
  imports: [MatProgressBarModule, SharedModule, PraticaTitleComponent],
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.scss'],
})
export class StatusBarComponent {
  get percentage() {
    return this.praticaProgressService.total.pipe(
      map((progress) => `Completati: ${progress}%`)
    );
  }

  constructor(public praticaProgressService: PraticaProgressService) {}
}
